import { ImagingStudyList } from "./components/ImagingStudyList";

const resource = {
  list: ImagingStudyList,
};

export default resource;
